import {
  OnUserActionRequiredFn,
  OnUserActionRequiredReturnType,
} from '@/shared/lib/sj-orm/migrator';
import { useModalsStore } from '@/widgets/modals/modals.store';

export const useUpdateCollectionsByUser = () => {
  const modals = useModalsStore();

  const updateCollections: OnUserActionRequiredFn = async ({ collections }) => {
    const fillPromise = new Promise<OnUserActionRequiredReturnType>((resolve) => {
      modals.openModal({
        type: 'UpdateCollectionsModal',
        collections,
        onSubmit: (updatedCollections) => resolve({ collections: updatedCollections }),
      });
    });

    const updatedData = await fillPromise;

    return updatedData;
  };

  return { updateCollections };
};
